import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH, UNAUTHENTICATED_ENTRY } from 'configs/AppConfig'

const AdminRoute = () => {
    const { token, role } = useSelector(state => state.auth)

    if (!token) {
        return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}`} />
    }

    if (role !== 'ROLE_ADMIN') {
        return <Navigate to={`${APP_PREFIX_PATH}/home`} />
    }

    return <Outlet />
}

export default AdminRoute
